(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-blown-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Play hybrid-card videos on hover, pause/reset on leave
  // Guard prevents duplicate listeners if the section is re-rendered at runtime (theme editor, AJAX)
  if (!window.__hybridCardVideoListeners) {
    window.__hybridCardVideoListeners = true;

    document.addEventListener('pointerenter', (e) => {
      if (!(e.target instanceof Element)) return;
      const link = e.target.closest('.hybrid-card__media-link');
      if (!link) return;
      const video = link.querySelector('.hybrid-card__video');
      if (video) video.play();
    }, true);

    document.addEventListener('pointerleave', (e) => {
      if (!(e.target instanceof Element)) return;
      const link = e.target.closest('.hybrid-card__media-link');
      if (!link) return;
      const video = link.querySelector('.hybrid-card__video');
      if (video) { video.pause(); video.currentTime = 0; }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-managed-collection"] && !Shopify.designMode) return;
  try {
    
  // Play hybrid-card videos on hover, pause/reset on leave
  // Guard prevents duplicate listeners if the section is re-rendered at runtime (theme editor, AJAX)
  if (!window.__hybridCardVideoListeners) {
    window.__hybridCardVideoListeners = true;

    document.addEventListener('pointerenter', (e) => {
      if (!(e.target instanceof Element)) return;
      const link = e.target.closest('.hybrid-card__media-link');
      if (!link) return;
      const video = link.querySelector('.hybrid-card__video');
      if (video) video.play();
    }, true);

    document.addEventListener('pointerleave', (e) => {
      if (!(e.target instanceof Element)) return;
      const link = e.target.closest('.hybrid-card__media-link');
      if (!link) return;
      const video = link.querySelector('.hybrid-card__video');
      if (video) { video.pause(); video.currentTime = 0; }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
